import querystring from 'querystring';
import xss from 'xss';
import { ISOStringToDate, isValidDateObject } from '../../helpers/time';
import { DateTimeFormatters } from '@showclix-projects/sc-intl';
import { fullDateRangeShort } from '@showclix-projects/sc-intl/dist/dateTimeFormatters';

export function toUrlParams(config) {
    let params = [];

    for (const key in config.styles) {
        params.push(key + "=" + encodeURIComponent(config.styles[key]));
    }

    if(config.images) {
        if(config.images['PAGE__background-image']) {
            params.push('PAGE__background-image='+encodeURIComponent(config.images['PAGE__background-image']));
            params.push('PAGE__background-image-dim='+encodeURIComponent(config.images['PAGE__background-image-dim']));
        }
    }

    if(config.partnerSlug) {
        params.push('GLOBAL__PARTNER__SLUG='+encodeURIComponent(config.partnerSlug));
        params.push('GLOBAL__PARTNER__URL='+encodeURIComponent(config.partnerUrl));
    }

    return params.join("&");
}

export function scrollToTop() {
    if(document.getElementById("checkout-wrap")) {
        document.getElementById("checkout-wrap").scrollTo(0,0);
    }
}

export function serializeToUrl(object) {
    return querystring.stringify(object);
}

export function getErrorText(e) {
    if(!Array.isArray(e)) {
        e = [e];
    }

    let msg = "";

    for(let i = 0; i < e.length; i++) {
        if(typeof e[i] === "string") {
            msg = e[i];
            break;
        } else if(typeof e[i] === "object" && e[i] !== null) {
            msg = e[i].detail;
        }
    }

    return msg;
}

export function getXssFilter() {
    const options = {
        whiteList: {
            p: ["style"],
            span: ["style"],
            a: ["href", "style", "target"],
            li: ["style"],
            ul: ["style"],
            ol: ["style"],
            table: ["style", "border"],
            caption: ["style"],
            tbody: ["style"],
            th: ["style"],
            tr: ["style"],
            td: ["style"],
            img: ["style", "src", "alt", "width", "height"],
            em: [],
            strong: [],
            br: [],
            h1: ["style"],
            h2: ["style"],
            h3: ["style"],
            h4: ["style"],
            h5: ["style"],
            h6: ["style"],
            sup: [],
            sub: [],
            blockquote: [],
            div: [],
            pre: [],
            code: [],
            center: [],
            iframe: ["src", "width", "height", "frameborder", "allowfullscreen", "data-mce-fragment"]
        },
        css: {
            whiteList: {}
        }
    }

    options.css.whiteList['text-align'] = true;
    options.css.whiteList['text-decoration'] = true;
    options.css.whiteList['padding-left'] = true;
    options.css.whiteList['border-collapse'] = true;
    options.css.whiteList['width'] = true;
    options.css.whiteList['height'] = true;
    options.css.whiteList['margin'] = true;
    options.css.whiteList['display'] = true;
    options.css.whiteList['max-height'] = true;
    options.css.whiteList['max-width'] = true;

    return new xss.FilterXSS(options);
}

/**
 * Helper function to strip internal attrs off of state to make it serializable
 */
export function stateToString(state) {
    let newState = {};

    for (const key in state) {
        if(!key.startsWith('_') && key !== "router") {
            try {
                JSON.stringify(state[key]);
            } catch (e) {
                continue;
            }

            newState[key] = state[key];
        }
    }

    return JSON.stringify(newState);
}

/**
 * returns a function that can be passed to focusTrapOptions.initialFocus to set the element to
 * initially focus on when using focus-trap-react.  By using this, we can pass a selector without
 * having to validate that the elements we are referencing exist or worry about an error being thrown.
 * In the event that a selector is passed that does not reference any dom elements, this will return false,
 * and nothing will be initially focused when the focus trap activates.
 * @param  string selector
 * @return function
 */
export const getInitialFocusSelector = selector => {
    return () => {
        const numberNodes = document.querySelectorAll(selector).length;
        return numberNodes ? selector : false;
    }
}

/**
 * Get localized event date string. If the event has an end, returns a range.
 * @param  string eventStart
 * @param  string eventEnd
 * @param  string locale
 * @return string
 */
export function getEventDate(eventStart, eventEnd, locale) {
    const { fullDateShort } = DateTimeFormatters;

    if (typeof eventStart !== "string") {
        return '';
    }

    let startDate = ISOStringToDate(eventStart);
    if (!isValidDateObject(startDate)) {
        return '';
    }

    let endDate = null;
    if(eventEnd && typeof eventEnd === 'string') {
        endDate = ISOStringToDate(eventEnd);
        if (isValidDateObject(endDate)) {
            return fullDateRangeShort(locale, startDate, endDate);
        }
    }

    return fullDateShort(locale, startDate);
}
